import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { HOTEL_AMENITIES_COLUMN } from 'constants/hotelAmenities'
import { GooglePlaceChainBase, LodgingChain } from 'models/google_place_chain'
import { getGooglePlaceBaseColumns } from '../GooglePlaceBase/GooglePlaceBaseColumnsInfo'

// Lodging-only columns get spread alongside the shared GooglePlaceBase set so
// the divergence from cstore is in one obvious place.
export const LODGING_COLUMNS = {
  ...getGooglePlaceBaseColumns('Lodging'),
  hotel_amenities: HOTEL_AMENITIES_COLUMN,
} satisfies Partial<
  Record<
    keyof GooglePlaceChainBase | keyof LodgingChain | 'hotel_amenities',
    DataTypeColumn
  >
>
